import { DeclaracionModelo349DtoProps } from "api/DTOs/DeclaracionModelo349Dto"
import { OperadorIntracomDeclaracionModelo349DtoProps } from "api/DTOs/OperadorIntracomDeclaracionModelo349Dto"
import { PeriodoDeclaracionModeloEnumType } from "api/Types/PeriodoDeclaracionModeloEnum"

interface OperadorIntracomFormModel {
  baseImponible?: number | null
  clave?: string | null
  codigoPais?: string | null
  nif?: string | null
  razonSocial?: string | null
}

export interface Modelo349FormModel extends DeclaracionModelo349DtoProps {
  "01": number | null
  "03": number | null
  period: { label: string; value: PeriodoDeclaracionModeloEnumType[] } | null
}

export const postModelo349Adapter = (
  formData: Modelo349FormModel
): DeclaracionModelo349DtoProps => {
  return {
    declarante: {
      apellidoNombrePersona: formData?.declarante?.apellidoNombrePersona,
      cambioPeriodicidadObligacionDeclarar:
        formData?.declarante?.cambioPeriodicidadObligacionDeclarar,
      declaracionComplementaria: formData?.declarante.declaracionComplementaria,
      declaracionSustitutiva: formData?.declarante.declaracionSustitutiva,
      importeOperacionesIntracom:
        formData?.declarante.importeOperacionesIntracom,
      importeRectificaciones: formData?.declarante.importeRectificaciones,
      nifDeclarante: formData?.declarante?.nifDeclarante,
      nifRepresentante: formData?.declarante?.nifRepresentante,
      nombreDeclarante: formData?.declarante?.nombreDeclarante,
      numeroIdentificativoDeclaracionAnterior:
        formData?.declarante?.numeroIdentificativoDeclaracionAnterior,
      numeroTotalOperadoresIntracom: formData?.["01"],
      numeroTotalOperadoresIntracomRectificaciones: formData?.["03"],
      telefonoPersona: formData?.declarante?.telefonoPersona,
    },
    ejercicio: formData?.ejercicio,
    operadores: formData?.operadores?.length
      ? formData?.operadores?.map(
          (
            operador?: OperadorIntracomFormModel
          ): OperadorIntracomDeclaracionModelo349DtoProps => ({
            baseImponible: operador?.baseImponible,
            claveOperacion: operador?.clave,
            codigoPaisOperador: operador?.codigoPais,
            nifDeclarante: undefined, // No se envia a pedido del back
            nifOperadorComunitario: operador?.nif,
            nifSustituto: undefined, // No se envia a pedido del back
            nombreOperadorIntracom: operador?.razonSocial,
            nombreSustituto: undefined, // No se envia a pedido del back
          })
        )
      : null,
    periodo: formData?.period?.value ?? null,
  }
}
